import * as firebase from 'firebase';

var firebaseConfig = {
    apiKey: "AIzaSyC_85juOfEOgHk6oSwcxFMTxilVlhA2xNM",
    authDomain: "myportfolio-b3163.firebaseapp.com",
    databaseURL: "https://myportfolio-b3163.firebaseio.com",
    projectId: "myportfolio-b3163",
    storageBucket: "myportfolio-b3163.appspot.com",
    messagingSenderId: "126218419198",
    appId: "1:126218419198:web:d4c8e0395a5b6ab0905eaf",
    measurementId: "G-64XHBWQDNH"
};
// Initialize Firebase
const fire = firebase.initializeApp(firebaseConfig);

export default fire;